const menuList = [
  {
    label: "属性",
    value: "attrs",
    img: "attrs"
  },
  // {
  //   label: "装备",
  //   value: "equip",
  //   img: "equip"
  // },
  {
    label: "背包",
    value: "pack",
    img: "pack"
  },
  {
    label: "商城",
    value: "shop",
    img: "shop"
  },
  {
    label: "无尽之塔",
    value: "tower",
    img: "rank1"
  }
  // {
  //   label: "迁移",
  //   value: "save",
  //   img: "save"
  // }
];
const updateLog = [
  "因新版本需要，很抱歉清空了您的存档",
  "商店新增批量购买，再也不用花钱花到手抽筋了",
  "新增批量吃药，一次让您吃个饱",
  "新增一键整理，按照……锁定->消耗品->装备->品级……排序",
  "新增消息分类和清除信息，现在您可以清晰的看到系统消息和玩家消息，且清空你想要的板块",
  "一键出售优化，当您一次性售卖超多装备时不再会像从前一样卡顿了，并且现在不再出售史诗装备了",
  "装备生成调整，暴击率不再参与装备等级加成，装备的基础属性也将参与属性浮动",
  "装备对比bug修复，之前更换装备后其他装备的对比依旧显示之前穿戴的装备",
  "词条调整，鹰眼削减的攻速从0.2降低至0.1，三维和攻击血量防御词条皆获得一定提升",
  "新增20级神器装备，21-25级基本装备，猛毒猫妖、猫妖王怪物，迷雾沼泽副本，猫妖塔"
];
export { menuList, updateLog };
